import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { getArcadeLinkStyles, getSubtleNumberStyles, spacing } from '@cash-design-system/react'
// todo: fix once breakpoints available from arcade
// eslint-disable-next-line no-restricted-imports
import { BreakpointSmall } from '@cash-design-system/tokens'

export const LinkAndAnchorStyles = (props: { theme: Theme }) => css`
  ${getArcadeLinkStyles(props.theme)}
  text-decoration: none;
`

export const StyledStructuredContentForArticle = (props: { theme: Theme }) => css`
  margin: ${props.theme.spacing.empty};

  > * {
    max-width: 100%;
  }

  h2 {
    ${props.theme.typography.sectionTitle}
  }

  h3,
  h4,
  h5 {
    ${props.theme.typography.titleBarPageTitle}
  }

  ${props.theme.typography.body}
  line-height: 1.7; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */

  @media (min-width: ${props.theme.breakpoints.tablet}) {
    ${props.theme.typography.body}
    line-height: 1.7; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
  }

  p:first-of-type {
    margin-top: 0;
  }

  p:last-of-type {
    margin-bottom: 0;
  }

  img {
    max-height: 600px;
  }

  ol,
  ul {
    /*
     These padding changes are so that numbered lists and bulleted
     lists line up. We are using "em" rather than "rem" so we can
     have the padding amount increased as the parent's font size increases
     to leave enough room for the number
     */

    padding-left: 1.5em;

    li {
      padding-left: 0.5em;
    }
  }

  ol {
    list-style: none;
    counter-reset: list;
    row-gap: ${spacing.xs};
    display: grid;

    & > li {
      counter-increment: list;
      display: flex;
      align-items: center;
      position: relative;

      &::before {
        ${getSubtleNumberStyles(props.theme)}

        content: counter(list);

        /* Move the number box to left */
        left: 0;
        top: 2px;

        /* Essentually removes the space left by relative pos */
        margin-left: -1.5em;

        /* align to center */
        text-align: center;

        position: absolute;
      }
    }
  }
`

export const ContentContainerStyles = css`
  padding-top: ${spacing.defaultContent};
  padding-bottom: ${spacing.xl};
  display: flex;
  flex-direction: column;
  gap: ${spacing.xl};
  margin: 0 auto;

  @media (min-width: ${BreakpointSmall}) {
    padding-bottom: 60px;
  }
`

export const Content = styled.div`
  width: 100%;
  max-width: 810px;
  padding: 0 1.5rem;
`
